// extracted by mini-css-extract-plugin
export default {"description":"RequestForgottenPasswordEmailSuccess_description__U13jV","button":"RequestForgottenPasswordEmailSuccess_button__eRBz3"};